/**
 * @file 一般请求
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-10-24 Baidu
 */
import {message} from 'antd';
import api from '../config';
import {tokenUpdateCode} from '../common/enum';
import {setTongJiKey} from '../common/bdtj';

export let getUserInfo = () => {
    return dispatch => {
        // 获取用户来源
        // 1、url中有utm_source，则直接获取该参数值并传递该参数
        // 2、没有utm_source参数，则获取上一跳网址作为参数传递给用户信息接口（需要排除域名dwz.cn和test.dwz.cn）
        // 3、如果以上两种方法都没有获取到来源信息，则不传参数
        var query = '';
        var utmSource = getQueryVariable('utm_source');
        if (utmSource !== null && utmSource !== '') {
            query = 'utm_source=' + utmSource;
        }
        var referrer = getReferrerDomain();
        if (referrer !== null && referrer !== '') {
            query = 'utm_source=' + referrer;
        }
        api.getUserInfo({}, {}, query).then(data => {
            // 动态设置百度统计代码
            setTongJiKey(data.DisplayName || '');
            if (data.Code === 0) {
                dispatch(updateUserInfoAction(data.DisplayName));
                dispatch(updateTokenAction(data.Token));
                // 用户为欠费状态，则无需调用FreePoint字段
                if (data.InArrears === true) {
                    dispatch(updateInArrearsAction(data.InArrears));
                } else if (data.InArrears === false) {
                    // 用户为未欠费状态，调用FreePoint字段
                    dispatch(updateInArrearsAction(data.InArrears));
                    dispatch(updateFreePointAction(data.FreePoint));
                }
                // 用户可用付费点数获取
                dispatch(updatePaidAction(data.Paid));
                // 如果为新用户，15秒后弹出对话框
                // if (data.New === true) {
                //     setTimeout(function () {
                //         // window.BaiduConv.showChat();
                //     }, 15000);
                // }
            }
        })
        .catch((e) => {
            setTongJiKey('');
            if (e.status !== 200) {
                localStorage.setItem('login_status', false);
                 // 如果未登录，15秒后弹出对话框
                // setTimeout(function () {
                //     window.BaiduConv.showChat();
                // }, 15000);
            }
        });
    };
};

export let setToken = method => {
    return dispatch => {
        api.tokenAction({}, {method}).then(data => {
            if (data.Code === 0) {
                dispatch(updateTokenAction(data.Token));
            }
            else {
                message.error(tokenUpdateCode[data.Code]);
            }
        });
    };
};

export let setCurrentPage = currentPage => {
    return dispatch => {
        dispatch(updateCurrentPage(currentPage));
    };
};
// 用户是否欠费状态获取
function updateInArrearsAction(inArrears) {
    return {
        type: 'UPDATE_INARREARS',
        inArrears: inArrears
    };
}
// 是否为付费用户数据
function updatePaidAction(paid) {
    return {
        type: 'UPDATE_PAID',
        paid: paid
    };
}
// 用户免费点数数据
function updateFreePointAction(freePoint) {
    return {
        type: 'UPDATE_FREE_POINT',
        freePoint: freePoint
    };
}
function updateUserInfoAction(displayName) {
    return {
        type: 'UPDATE_USER_INFO',
        userName: displayName
    };
}
function updateTokenAction(token) {
    return {
        type: 'UPDATE_TOKEN',
        token
    };
}
function updateCurrentPage(currentPage) {
    return {
        type: 'UPDATE_CURRENT_PAGE',
        currentPage: currentPage
    };
}
// 获取url中的参数值
function getQueryVariable(variable) {
    let query = window.location.search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return null;
}

// 获取referrer的域名，排除短网址域名
function getReferrerDomain() {
    var referrer = document.referrer;
    var referrerDomain = referrer.split('/');
    if (referrerDomain[2] && referrerDomain[2] !== '' && !isInExceptDomainList(referrerDomain[2])) {
        return referrerDomain[2];
    } else {
        return '';
    }
}

// 判断是否为需要排除的域名
function isInExceptDomainList(domain) {
    var regexOfDomain = new RegExp('.*(passport\.baidu\.com|dwz\.cn|hm\.baidu\.com)$');
    if (regexOfDomain.test(domain)) {
        return true;
    }
    return false;
}